export default __webpack_public_path__ + "static/media/placeholder3.bb80088b.png";